import { useMemo } from 'react';
import { PartnersListItemResponseV2Dto } from '@tiendanube/common';
import { useListMobile } from 'App/hooks';
import { UsersEndpoints } from 'domains/Configurations/Users/usersApi';

function usePartnersListMobile() {
  const result = useListMobile<PartnersListItemResponseV2Dto>({
    filters: { perPage: '20' },
    endpoint: UsersEndpoints.getPartnersListInf,
  });

  const ids = useMemo(
    () => result?.data?.map?.((current) => current.id) ?? [],
    [result?.data],
  );
  return { ...result, ids };
}

export default usePartnersListMobile;
